import { render } from "./popup_sleeping.vue?vue&type=template&id=325ef1ec"
import script from "./popup_sleeping.vue?vue&type=script&lang=js"
export * from "./popup_sleeping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__